module.exports = __webpack_public_path__ + "assets/img/1-14.378215dc.png";